// Mapa de assuntos da tela Parâmetros do Embarcador (H1, PO1-3259). Casa pelo Id do
// catálogo (EMBARC); label/ajuda em português para o usuário final — a ajuda diz o
// efeito prático, não o nome técnico. Sem label/ajuda aqui, a tela usa nome/descricao
// do catálogo. Conectores (protheus*, esp*, sefaz*, obcUsuario) e os ocultos
// (EnviarEmail, obcUrlAPI, obcToken) não entram: ficam em Integrações.
const MAPA_EMBARCADOR = [
  {
    key: "prazo-entrega",
    titulo: "Prazo de entrega",
    descricao: "Como o Hub calcula a data prevista de entrega a partir da emissão da nota.",
    blocos: [
      {
        titulo: "Contagem do prazo",
        campos: [
          {
            id: 1,
            label: "Dias adicionais ao prazo da tabela",
            ajuda: "Dias somados ao prazo da tabela de frete em toda entrega. Use para folga operacional (ex.: 1 dia de separação).",
          },
          {
            id: 2,
            label: "Hora de corte da emissão",
            ajuda: "Nota emitida depois desse horário começa a contar o prazo no dia seguinte.",
          },
          {
            id: 3,
            label: "Tipo de dias do prazo",
            ajuda: "Dias úteis (pula sábado e domingo), úteis com sábado (pula só domingo) ou corridos.",
          },
          {
            id: 4,
            label: "Considerar feriados da origem",
            ajuda: "Feriados do município de origem não contam no prazo.",
          },
          {
            id: 5,
            label: "Considerar feriados do destino",
            ajuda: "Feriados do município de destino não contam no prazo.",
          },
        ],
      },
    ],
  },
  {
    key: "sla-sac",
    titulo: "SLA do SAC",
    descricao: "Prazos de resposta dos chamados (tickets) abertos com as transportadoras.",
    blocos: [
      {
        titulo: "Prazo do ticket",
        campos: [
          { id: 6, label: "Horas acumuladas no SLA", ajuda: "Horas somadas ao prazo de cada ticket antes de ele contar como atrasado." },
          { id: 7, label: "Hora de corte do SLA", ajuda: "Ticket aberto depois desse horário começa a contar o SLA no dia seguinte." },
          { id: 8, label: "Tipo de dias do SLA", ajuda: "Dias úteis, úteis com sábado ou corridos na contagem do SLA." },
          { id: 9, label: "Considerar feriados do remetente", ajuda: "Feriados do município do remetente não contam no SLA." },
          { id: 10, label: "Considerar feriados do destinatário", ajuda: "Feriados do município do destinatário não contam no SLA." },
        ],
      },
      {
        titulo: "Horário de atendimento",
        campos: [
          { id: 11, label: "Início do expediente", ajuda: "O SLA só corre dentro do expediente. Hora em que ele começa a contar no dia." },
          { id: 12, label: "Fim do expediente", ajuda: "Hora em que o SLA para de contar no dia." },
        ],
      },
    ],
  },
  {
    key: "fatura",
    titulo: "Fatura",
    descricao: "Conferência, liberação e vencimento das faturas de frete.",
    blocos: [
      {
        titulo: "Conferência e liberação",
        campos: [
          { id: 195, label: "Conferência automática da fatura", ajuda: "Ao receber a fatura, o Hub confere os CT-es sozinho, sem esperar alguém abrir a fila." },
          { id: 196, label: "Liberação automática", ajuda: "Fatura conferida sem divergência é liberada para pagamento sem aprovação manual." },
          { id: 197, label: "Responsável padrão pela fatura", ajuda: "Usuário (e-mail) que recebe as faturas novas para análise quando não há regra específica." },
          { id: 198, label: "Aceitar fatura vencida com divergência", ajuda: "Permite seguir com a conferência mesmo quando a fatura já venceu e tem divergência." },
          { id: 94, label: "Aceitar vencimento calculado", ajuda: "Quando a fatura não traz vencimento, o Hub usa o vencimento calculado pelas regras do embarcador." },
        ],
      },
      {
        titulo: "Regras de composição",
        campos: [
          { id: 18, label: "Só faturar com ocorrência finalizadora", ajuda: "Só aceita na fatura o CT-e cuja entrega já foi concluída (ocorrência de finalização)." },
          { id: 24, label: "Lançamentos por débito/crédito", ajuda: "Quantidade de lançamentos de débito e crédito aceitos por fatura." },
        ],
      },
    ],
  },
  {
    key: "auditoria-cte",
    titulo: "Auditoria de CT-e",
    descricao: "Tolerâncias e validações aplicadas a cada CT-e recebido.",
    blocos: [
      {
        titulo: "Tolerância de divergência",
        campos: [
          { id: 17, label: "Divergência tolerada (%)", ajuda: "Diferença percentual entre o frete cobrado e o calculado que ainda é aceita sem apontar divergência." },
          { id: 90, label: "Divergência tolerada (R$)", ajuda: "Diferença em reais que ainda é aceita sem apontar divergência. Vale a que for mais favorável." },
        ],
      },
      {
        titulo: "Dados atualizados pelo CT-e",
        campos: [
          { id: 76, label: "Atualizar destinatário pela nota do CT-e", ajuda: "O destinatário do CT-e corrige o destinatário da nota no Hub." },
          { id: 80, label: "Atualizar transportadora pelo CT-e", ajuda: "A transportadora emitente do CT-e passa a ser a transportadora da nota." },
          { id: 78, label: "Atualizar valor da nota pela soma dos itens", ajuda: "Recalcula o valor da nota somando os itens antes de auditar o frete." },
          { id: 79, label: "Atualizar valor da nota pelo valor da carga do CT-e", ajuda: "Usa o valor da carga declarado no CT-e como valor da nota na auditoria." },
          { id: 164, label: "Associar transportadora automaticamente", ajuda: "Vincula ao embarcador a transportadora que emitiu o CT-e, sem cadastro manual." },
          { id: 154, label: "Cadastrar transportadora desconhecida", ajuda: "Cria o cadastro da transportadora quando o CT-e vem de um CNPJ que o Hub não conhece." },
          { id: 165, label: "Vincular nota pela observação do CT-e", ajuda: "Quando a chave da nota não vem no CT-e, procura o número da nota no campo de observações." },
        ],
      },
      {
        titulo: "Redespacho",
        campos: [{ id: 101, label: "Aceitar CT-e de redespacho", ajuda: "Aceita CT-e emitido pela transportadora que recebeu a carga de outra (redespacho)." }],
      },
    ],
  },
  {
    key: "calculo-frete",
    titulo: "Cálculo de frete",
    descricao: "Como o Hub calcula o frete esperado das notas e dos CT-es.",
    blocos: [
      {
        titulo: "Serviço de cálculo",
        campos: [
          {
            id: 73,
            label: "Calcular frete das notas",
            ajuda: "Liga o cálculo automático do frete das notas fiscais. Desligar para a auditoria de frete deste embarcador.",
            confirmarAoDesligar: true,
          },
          {
            id: 81,
            label: "Calcular frete dos CT-es",
            ajuda: "Liga o cálculo do frete esperado de cada CT-e recebido. Desligar deixa a conferência sem valor de referência.",
            confirmarAoDesligar: true,
          },
          { id: 82, label: "Agrupar notas pela data de entrega", ajuda: "Notas com a mesma data de entrega são calculadas como uma única carga." },
          { id: 83, label: "Agrupar notas pelo CT-e", ajuda: "Notas do mesmo CT-e são calculadas juntas, como uma carga só." },
          { id: 110, label: "Tipo de serviço genérico", ajuda: "Tipo de serviço usado no cálculo quando a nota não informa um." },
        ],
      },
      {
        titulo: "Piso mínimo ANTT",
        descricao: "Comparação do frete com o piso mínimo da tabela ANTT.",
        campos: [
          { id: 102, label: "Avaliar piso mínimo ANTT", ajuda: "Compara cada frete com o piso mínimo da ANTT e aponta os que ficaram abaixo." },
          { id: 105, label: "Tipo de carga padrão", ajuda: "Tipo de carga da tabela ANTT usado quando a nota não informa." },
          { id: 103, label: "Tipo de veículo padrão (código)", ajuda: "Código do tipo de veículo usado no piso ANTT quando o CT-e não informa." },
          { id: 104, label: "Carga mínima para lotação (kg)", ajuda: "A partir desse peso o frete é tratado como lotação na comparação com o piso." },
          { id: 106, label: "Calcular piso por veículo", ajuda: "Usa o veículo (eixos) para achar o piso da ANTT." },
          { id: 108, label: "Calcular piso por peso", ajuda: "Usa o peso da carga para achar o piso da ANTT." },
          { id: 107, label: "Peso médio por veículo (kg)", ajuda: "Peso usado para converter o piso por veículo em piso por quilo." },
        ],
      },
    ],
  },
  {
    key: "cotacao",
    titulo: "Cotação",
    descricao: "Regras da cotação de frete e das aprovações.",
    blocos: [
      {
        titulo: "Aprovação",
        campos: [
          { id: 162, label: "Aprovadores da cotação", ajuda: "E-mails (separados por vírgula) de quem aprova cotações acima da alçada." },
          { id: 163, label: "Tolerância acima do orçado (%)", ajuda: "Até esse percentual acima do orçado a cotação segue sem aprovação." },
          { id: 204, label: "E-mail de solicitação de alçada", ajuda: "Envia e-mail aos aprovadores quando a cotação ultrapassa a alçada." },
          { id: 97, label: "E-mail ao aprovar cotação", ajuda: "Avisa o solicitante por e-mail quando a cotação é aprovada." },
        ],
      },
      {
        titulo: "Localização",
        campos: [{ id: 92, label: "Usar cidade quando não houver CEP", ajuda: "Sem CEP na nota, cota pela cidade de destino em vez de recusar." }],
      },
    ],
  },
  {
    key: "notas-fiscais",
    titulo: "Notas fiscais",
    descricao: "Importação, agrupamento e tratamento das notas fiscais.",
    blocos: [
      {
        titulo: "Importação automática",
        campos: [
          { id: 53, label: "Importar notas automaticamente", ajuda: "Notas recebidas (SFTP, API, captura) entram no Hub sem ação manual." },
          { id: 52, label: "Importar CT-es automaticamente", ajuda: "CT-es recebidos entram no Hub sem ação manual." },
          { id: 51, label: "Importar faturas automaticamente", ajuda: "Faturas recebidas entram na fila de conferência sem ação manual." },
          { id: 35, label: "Robô importa notas", ajuda: "Permite que o robô de importação processe notas fiscais." },
          { id: 36, label: "Robô importa CT-es", ajuda: "Permite que o robô de importação processe CT-es." },
          { id: 37, label: "Robô importa ocorrências", ajuda: "Permite que o robô de importação processe ocorrências de entrega." },
          { id: 38, label: "Robô importa faturas", ajuda: "Permite que o robô de importação processe faturas." },
        ],
      },
      {
        titulo: "Transportadora da nota",
        campos: [
          { id: 20, label: "Buscar transportadora na simulação (CSV)", ajuda: "Na importação por CSV, escolhe a transportadora pela simulação de frete quando a nota não informa." },
          { id: 21, label: "Buscar transportadora na simulação (XML)", ajuda: "Na importação por XML, escolhe a transportadora pela simulação de frete quando a nota não informa." },
          { id: 22, label: "Buscar transportadora na simulação (TXT)", ajuda: "Na importação por TXT, escolhe a transportadora pela simulação de frete quando a nota não informa." },
          { id: 87, label: "Associar transportadora automaticamente", ajuda: "Vincula ao embarcador a transportadora informada na nota, sem cadastro manual." },
          { id: 98, label: "Cadastrar transportadora desconhecida", ajuda: "Cria o cadastro da transportadora da nota quando o CNPJ não existe no Hub." },
          { id: 100, label: "Usar o embarcador como transportadora", ajuda: "Nota sem transportadora é tratada como frete próprio (o embarcador transporta)." },
        ],
      },
      {
        titulo: "Valores e agrupamento",
        campos: [
          { id: 32, label: "Habilitar aglutinação de notas", ajuda: "Permite juntar várias notas num único cálculo de frete." },
          { id: 86, label: "Somar IPI no valor do item", ajuda: "O IPI entra no valor da mercadoria usado no cálculo do frete." },
          { id: 109, label: "Converter CT-e em nota", ajuda: "Quando não há nota, cria uma a partir do CT-e para permitir a auditoria." },
        ],
      },
    ],
  },
  {
    key: "sftp",
    titulo: "Arquivos no SFTP",
    descricao: "O que acontece com os arquivos que chegam pelas pastas de SFTP.",
    blocos: [
      {
        titulo: "Encaminhar para a API",
        campos: [
          { id: 71, label: "Notas do SFTP vão para a API", ajuda: "Arquivos de nota recebidos no SFTP são processados pela API, como se fossem enviados por integração." },
          { id: 72, label: "CT-es do SFTP vão para a API", ajuda: "Arquivos de CT-e recebidos no SFTP são processados pela API." },
          { id: 85, label: "Faturas do SFTP vão para a API", ajuda: "Arquivos de fatura recebidos no SFTP são processados pela API." },
          { id: 199, label: "Ocorrências do SFTP vão para a API", ajuda: "Arquivos de ocorrência (OCOREN) recebidos no SFTP são processados pela API." },
          { id: 95, label: "Redirecionar CT-e para a pasta de fatura", ajuda: "CT-e que chega na pasta errada é movido para a pasta de fatura em vez de ser recusado." },
        ],
      },
    ],
  },
  {
    key: "emails",
    titulo: "E-mails",
    descricao: "Destinatários e textos dos e-mails enviados pelo Hub.",
    blocos: [
      {
        titulo: "E-mail de fatura",
        campos: [
          { id: 151, label: "Destinatários", ajuda: "E-mails (separados por vírgula) que recebem o aviso de fatura." },
          { id: 152, label: "Em cópia", ajuda: "E-mails copiados em todo aviso de fatura." },
          { id: 153, label: "Assunto", ajuda: "Assunto do e-mail de fatura." },
        ],
      },
      {
        titulo: "Outros envios",
        campos: [
          { id: 45, label: "Gerar CONEMB", ajuda: "Gera o arquivo CONEMB (retorno da conferência da fatura) para enviar à transportadora." },
          { id: 96, label: "E-mail da sustentação", ajuda: "Endereço que recebe os avisos técnicos deste embarcador (falhas de importação, integrações)." },
        ],
      },
    ],
  },
  {
    key: "limpeza",
    titulo: "Limpeza automática",
    descricao: "Rotinas que apagam o que já não precisa ficar guardado.",
    blocos: [
      {
        titulo: "Filas de trabalho",
        campos: [
          { id: 54, label: "Limpar arquivos duplicados da fila", ajuda: "Remove da fila de trabalho arquivos recebidos em duplicidade." },
          { id: 55, label: "Limpar faturas vencidas da fila", ajuda: "Tira da fila de conferência as faturas que já venceram sem tratamento." },
          { id: 58, label: "Limpar itens de local diferente", ajuda: "Remove da fila itens cujo local de entrega não bate com o esperado." },
        ],
      },
      {
        titulo: "Arquivos do SFTP",
        campos: [
          { id: 56, label: "Limpar o SFTP automaticamente", ajuda: "Apaga do SFTP os arquivos antigos já processados." },
          { id: 57, label: "Dias de retenção no SFTP", ajuda: "Arquivos mais antigos que isso são apagados pela limpeza." },
        ],
      },
    ],
  },
  {
    key: "outros",
    titulo: "Outros",
    descricao: "Parâmetros gerais que não se encaixam nos outros assuntos.",
    blocos: [
      {
        titulo: "Geral",
        campos: [{ id: 42, label: "Embarcador atua como agência", ajuda: "Trata este embarcador como agência de cargas (opera fretes de terceiros)." }],
      },
    ],
  },
];

export default MAPA_EMBARCADOR;
